import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ValidacionDocumentosPendientesFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='validacionDocumentosPendientes'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-validacionDocumentosPendientes'
              label='Validación documentos pendientes'
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(ValidacionDocumentosPendientesFormGroup)
